import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import {
  Ch_signPsychotherapyPrescriptionDocumentInput,
  useChSignPsychologicalPsychotherapyMutation as useChSignPsychologicalPsychotherapyMutationType,
} from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChSignPsychologicalPsychotherapyMutation.graphql"

const mutation = graphql`
  mutation useChSignPsychologicalPsychotherapyMutation($input: Ch_signPsychotherapyPrescriptionDocumentInput!) {
    ch_signPsychotherapyPrescriptionDocument(input: $input) {
      ch_PsychotherapyPrescription {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...chPsychologicalPsychoTherapyFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChSignPsychologicalPsychotherapyMutationType>, "variables"> & {
  id: Ch_signPsychotherapyPrescriptionDocumentInput["id"]
}

const useChSignPsychologicalPsychotherapyMutation = () => {
  const [commit, isFlight] = useMutation<useChSignPsychologicalPsychotherapyMutationType>(mutation)

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChSignPsychologicalPsychotherapyMutation }
